import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TextField from "@mui/material/TextField";
import TableHead from "@mui/material/TableHead";
import Autocomplete from "@mui/material/Autocomplete";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../CommonComponent/Button";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { visuallyHidden } from "@mui/utils";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelIcon from "@mui/icons-material/Cancel";
import { FileCopy as FileCopyIcon } from "@mui/icons-material";

import useHttp from "../../Hooks/use-http";
import RidersData from "./RidersData";
import "./DataTable.css";
import Modal from "../../GeneratePDF/Modal";

import ExtraKm from "./ExtraKm";

import HeaderFilter from "../CommonComponent/HeaderFilter";
import CommonTablePagination from "../CommonComponent/CommonTablePagination";
import { useHistory } from "react-router-dom";
import TripDetails from "./TripDetails";
import PortalTitle from "../CommonComponent/PortalTitle";
import {
  littleBlue,
  littleGreen,
  littleRed,
  littleYellow,
} from "../CommonComponent/DefineColors";
// import formatDateTime from "../CommonComponent/timeFormatT";
import { FormatDateTime } from "../CommonComponent/DateFormat";
import TripDistanceRoundOff from "../CommonComponent/TripDistanceRoundOff";
import { PAGINATIONBASEVALUE } from "../../Constant";

let selectedDriverEmailId = "";
let changedDateTime = {
  date: "",
  time: "",
};
const RiderName = "VehicaleModel";
let dateTimeChangeFlag = 0;
let routeId = "";
let lineId = "";

function descendingComparator(a, b, orderBy) {
  let aValue = a[orderBy];
  let bValue = b[orderBy];

  // ✅ 1. Handle ActualTripTime
  if (orderBy === "ActualTripTime") {
    aValue = parseFloat(aValue) || 0;
    bValue = parseFloat(bValue) || 0;
  }

  // ✅ 2. Handle DriverDetails (parse and get DriverName)
  else if (orderBy === "DriverName") {
    try {
      aValue = JSON.parse(a.DriverDetails)?.DriverName || "";
      bValue = JSON.parse(b.DriverDetails)?.DriverName || "";
    } catch {
      aValue = "";
      bValue = "";
    }
  }

  // ✅ 3. Handle CorporateDetails (parse and get CorporateName)
  else if (orderBy === "CorporateName") {
    try {
      aValue = JSON.parse(a.CorporateDetails)?.name || "";
      bValue = JSON.parse(b.CorporateDetails)?.name || "";
    } catch {
      aValue = "";
      bValue = "";
    }
  }

  // ✅ Generic fallback for other types
  if (typeof aValue === "string") aValue = aValue.toLowerCase();
  if (typeof bValue === "string") bValue = bValue.toLowerCase();

  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}

const getHeadCells = (roleId) => [
  {
    id: "DriverTripID",
    numeric: false,
    disablePadding: true,
    label: "Trip Id",
    width: "140px",
  },
  {
    id: "DriverName",
    numeric: true,
    disablePadding: false,
    label: "Driver",
    width: "11%",
  },

  ...(roleId == "1"
    ? [
        {
          id: "CorporateName",
          numeric: true,
          disablePadding: false,
          label: "Corporate",
          width: "10.8%",
        },
      ]
    : []),
  {
    id: "TripType",
    numeric: false,
    disablePadding: false,
    label: "Type",
    width: "7%",
  },
  {
    id: RiderName,
    numeric: false,
    disablePadding: false,
    label: "Riders",
    // width: "10%",
  },
  {
    id: "ActualPickupDateTime",
    numeric: true,
    disablePadding: false,
    label: "Started",
    // width: "10%",
  },
  {
    id: "ActualDropDateTime",
    numeric: true,
    disablePadding: false,
    label: "Ended",
    // width: "10%",
  },

  {
    id: "ActualTripTime",
    numeric: true,
    disablePadding: false,
    label: "Duration",
    // width: "10%",
  },
  {
    id: "ActualTripDistance",
    numeric: true,
    disablePadding: false,
    label: "Distance",
  },
  {
    id: "TripStatus",
    numeric: false,
    disablePadding: false,
    label: "Status",
    // width: "9%",
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    roleId,
  } = props;
  const currentRoleId = roleId || localStorage.getItem("roleId");
  const headCells = getHeadCells(currentRoleId);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="none" style={{ width: "2%" }}></TableCell>
        {headCells.map((headCell, i) => {
          if (currentRoleId !== "1" && headCell.label === "Corporate") {
            return null;
          }
          return (
            <TableCell
              key={headCell.id}
              align="center"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy == headCell.id ? order : false}
              sx={{
                fontWeight: 600,
                fontSize: "0.875rem",
                py: 1,
                px: 2,
                color: "rgba(0, 0, 0, 0.87)",
                width: headCell.width,
              }}
            >
              <TableSortLabel
                // active={orderBy === headCell.id}
                active={true}
                direction={orderBy == headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  // debugger;
  const { selected, tripsData, setFilteredData } = props;
  const [searchValue, setSearchValue] = useState("");
  const [corporateData, setCorporateData] = useState([]);

  const [showPopup, setShowPopup] = useState(false);

  const handleAddKMClick = () => {
    setShowPopup(true);
  };

  return (
    <Toolbar
      sx={{
        minHeight: "auto",
        padding: "0 !important",
      }}
      variant="dense"
    >
      {selected.length > 0 ? (
        <Typography
          sx={{ flex: "1 1 100%" }}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {selected.length} selected
        </Typography>
      ) : null}

      {selected.length > 0 ? (
        <React.Fragment>
          <Tooltip title="Edit">
            <IconButton>
              <EditIcon onClick={() => props.setIsEditIconClicked(true)} />
            </IconButton>
          </Tooltip>
          <Tooltip title="Cancel">
            <IconButton>
              <CancelIcon
                onClick={() => props.setIsCancelBookingDialogOpen(true)}
              />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              // gap: "15px",
              width: "132%",
              textAlign: "center",
              minWidth: "min-content",
            }}
          >
            <HeaderFilter
              enableCorporateFilter={true}
              enableDateFilter={true}
              enableSearchFilter={true}
              corporateData={corporateData}
              setCorporateData={setCorporateData}
              selectedCorporate={props.selectedCorporateDetails}
              setSelectedCorporate={props.setSelectedCorporateDetails}
              setFilteredData={setFilteredData}
              mainData={tripsData}
              //  Search
              setSearchFilteredData={setFilteredData}
              data={tripsData}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              styling={{ marginTop: "10px" }}
              // Date
              startDateValue={props.startDateValue}
              endDateValue={props.endDateValue}
              setStartDateValue={props.setStartDateValue}
              setEndDateValue={props.setEndDateValue}
              setIsRefereshData={props.setIsRefereshData}
              loading={props.dataLoading}
            />

            <Button
              label="Export"
              variant="outlined"
              backgroundColor="#1D85C6"
              textColor="#1D85C6"
              sx={{
                color: "#1D85C6",
                border: "1px solid #1D85C6",
                ":hover": {
                  border: "1px solid #1D85C6",
                  color: "black",
                },
              }}
              size="small"
              onClick={() => props.setIsExportButtonClicked(true)}
            />
            {localStorage.getItem("roleId") == "1" && (
              <Button
                label="Update KM"
                variant="contained"
                backgroundColor="#44B150"
                sx={{
                  backgroundColor: "#44B150",
                  ":hover": {
                    backgroundColor: "#44B150",
                    opacity: 0.8,
                  },
                  boxShadow: "none",
                  fontFamily: "Montserrat",
                  fontSize: "12px",
                  padding: "8px 20px",
                  textTransform: "none",
                  minWidth: "110px",
                  marginLeft: "12px",
                }}
                size="medium"
                onClick={() => props.setIsAddKmButtonClicked(true)}
              />
            )}
          </div>
        </LocalizationProvider>
      )}
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function EditDriver({
  tripsData,
  selectedCorporateDetails,
  setSelectedCorporateDetails,
  dataLoading,
  setIsRefereshData,
  driversList,
  setStartDateValue,
  setEndDateValue,
  startDateValue,
  endDateValue,
  setTripsData,
  isSuperAdmin,
}) {
  const [order, setOrder] = React.useState("asc");
  const [filteredData, setFilteredData] = useState(tripsData);
  const [roleId, setRoleId] = React.useState(localStorage.getItem("roleId"));

  const [orderBy, setOrderBy] = React.useState("");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATIONBASEVALUE);

  // Listen for roleId changes in localStorage
  React.useEffect(() => {
    const handleStorageChange = () => {
      setRoleId(localStorage.getItem("roleId"));
    };

    // Check for changes periodically and on storage events
    const interval = setInterval(() => {
      const currentRoleId = localStorage.getItem("roleId");
      if (currentRoleId !== roleId) {
        setRoleId(currentRoleId);
      }
    }, 100);

    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [roleId]);
  const [isCancelBookingDialogOpen, setIsCancelBookingDialogOpen] =
    useState(false);
  const [isEditRouteBookingClicked, setIsEditRouteBookingClicked] =
    useState(false);
  const [isEditRouteBookingResponse, setIsEditRouteBookingResponse] =
    useState(false);
  const [isAddDriverClicked, setIsAddDriverClicked] = useState(false);
  const [allDriversList, setAllDriversList] = useState([]);
  const [isFillterIconClicked, setIsFilterIconClicked] = useState(false);
  const [isEditIconClicked, setIsEditIconClicked] = useState(false);
  const [expandedPanel, setExpandedPanel] = useState("");
  const [isTimeEdited, setIsTimeEdited] = useState(false);
  const [isConfirmCancelBookingClicked, setIsConfirmCancelBookingClicked] =
    useState(false);
  const [isCancelBookingResponse, setIsCancelBookingResponse] = useState(false);
  const [isExportButtonClicked, setIsExportButtonClicked] = useState(false);
  const [isAddKmButtonClicked, setIsAddKmButtonClicked] = useState(false);
  const [totalDistance, setTotalDistance] = useState(null);
  const [startedTripCount, setStartedTripCount] = useState(null);
  const [endedTripCount, setEndedTripCount] = useState(null);
  const history = useHistory();

  const { isLoading, sendRequest } = useHttp();

  const editRouteBookingResponse = (data) => {
    if (data.Message.toLowerCase() === "success") {
      setIsRefereshData(true);
      setIsEditRouteBookingResponse({
        status: "success",
        message: "Booking Edited Successfully",
      });
      selectedDriverEmailId = "";
      setSelected([]);
    } else
      setIsEditRouteBookingResponse({
        status: "error",
        message: data.SystemMessage,
      });
    setIsEditRouteBookingClicked(false);
  };

  const driverListDetails = (data) => {
    if (data?.DriverList) {
      setAllDriversList(
        data.DriverList
        //   data.DriverList.map(driver => {
        //   return {
        //     details: driver.DriverName + " - " + driver.Model + "(" + driver.Number + ")",
        //     emailId: driver.DriverEmailID
        //   }
        // }
        // )
      );
    }
  };

  const bookingCancelBookingResponse = (data) => {
    if (data.Message.toLowerCase() === "success") {
      setIsRefereshData(true);
      setIsCancelBookingResponse({
        status: "success",
        message: "Booking Cancelled Successfully",
      });
      selectedDriverEmailId = "";
      setSelected([]);
    } else
      setIsCancelBookingResponse({
        status: "error",
        message: data.SystemMessage,
      });
    setIsConfirmCancelBookingClicked(false);
  };

  React.useEffect(() => {
    let editbookings = "";
    if (selectedDriverEmailId) {
      if (selected.length > 0)
        editbookings = selected?.reduce((acc, cur) => {
          acc.push({
            RouteID: cur?.split(" ")[0],
            LineID: cur?.split(" ")[1],
            DriverEmailID: selectedDriverEmailId,
            ShuttleTime: "",
          });
          return acc;
        }, []);
      else {
        editbookings = [
          {
            RouteID: routeId,
            LineID: lineId,
            DriverEmailID: selectedDriverEmailId,
            ShuttleTime: "",
          },
        ];
      }
    } else {
      editbookings = [
        {
          RouteID: routeId,
          LineID: lineId,
          DriverEmailID: "",
          ShuttleTime: changedDateTime.date + " " + changedDateTime.time,
        },
      ];
    }
    if (isEditRouteBookingClicked) {
      sendRequest(
        {
          url: "/api/v1/ShuttleBooking/EditRouteBooking",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            editbookings: JSON.stringify(editbookings),
          },
        },
        editRouteBookingResponse
      );
    }
  }, [sendRequest, isEditRouteBookingClicked]);

  React.useEffect(() => {
    if (isConfirmCancelBookingClicked) {
      let cancelledbookings = selected.reduce((acc, cur) => {
        acc.push({
          RouteID: cur?.split(" ")[0],
          LineID: cur?.split(" ")[1],
        });
        return acc;
      }, []);
      sendRequest(
        {
          url: "/api/v1/ShuttleBooking/CancelledRouteBooking",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            cancelledbookings: JSON.stringify(cancelledbookings),
            riderTripID: "",
          },
        },
        bookingCancelBookingResponse
      );
    }
  }, [sendRequest, isConfirmCancelBookingClicked]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      // const newSelected = tripsData?.map((n) => n.DriverEmailID);
      // const newSelected = filteredData?.map((n) => n.DriverEmailID);
      const newSelected = filteredData?.map((n) => n.driverEmailID);

      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const handleClick = (event, name) => {
    // debugger;
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the l ast page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(filteredData, getComparator(order, orderBy))?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, filteredData, tripsData, isSuperAdmin]
  );

  const tDistance = filteredData?.reduce((acc, trip) => {
    // Convert from meters to kilometers
    // then round up to nearest integer
    const distance = trip?.ActualTripDistance
      ? Math.ceil(trip.ActualTripDistance / 1000)
      : 0;

    return acc + distance;
  }, 0);

  const formattedTotalDistance = tDistance.toString();

  const tripCounts = filteredData?.reduce(
    (acc, trip) => {
      if (trip?.TripStatus === "START_TRIP") {
        acc.started += 1;
      } else if (trip?.TripStatus === "END_TRIP") {
        acc.ended += 1;
      }
      return acc;
    },
    { started: 0, ended: 0 }
  );

  const startedTrips = tripCounts?.started;
  const endedTrips = tripCounts?.ended;

  React.useEffect(() => {
    setTotalDistance(formattedTotalDistance);
    setStartedTripCount(startedTrips);
    setEndedTripCount(endedTrips);
  }, [filteredData]);

  // For copying tripId----------------
  const [copiedItemId, setCopiedItemId] = useState(null);

  const handleCopyClick = (event, tripId) => {
    event.stopPropagation(); // Prevents row selection on click

    // Create a temporary textarea element
    const textArea = document.createElement("textarea");
    textArea.value = tripId;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      // Copy text using execCommand
      const successful = document.execCommand("copy");
      if (successful) {
        setCopiedItemId(tripId);
        setTimeout(() => setCopiedItemId(null), 2000);
      } else {
        console.error("Failed to copy text.");
      }
    } catch (err) {
      console.error("Error copying text:", err);
    }

    // Remove the textarea
    document.body.removeChild(textArea);
  };

  const getRiderInfo = (riderNames) => {
    try {
      // Parse the riderNames string into an array of objects
      const ridersArray = JSON.parse(riderNames);

      if (!Array.isArray(ridersArray)) {
        return ridersArray.riderName;
      }

      // Extract rider names from the array
      const namesArray = ridersArray
        .map((rider) => rider.riderName)
        .filter((name) => name.trim() !== "");

      // If no valid rider names are found, return "No riders"
      if (namesArray.length === 0) {
        // return "No riders";
        return "-";
      }

      // Get the first rider's name and the count of other riders
      const firstName = namesArray[0];
      const othersCount = namesArray.length;

      // Return the formatted string based on the number of riders
      if (namesArray.length === 1) {
        return `${firstName}`;
      } else if (namesArray.length > 1) {
        // return `${firstName}\n+ ${othersCount} others`;
        return (
          <>
            {firstName}
            <br /> ({othersCount} Riders){" "}
          </>
        );
      }
    } catch (error) {
      console.error("Error in getRiderInfo:", error);
      return "Invalid rider data";
    }
  };

  const statusMapping = {
    CANCEL_BY_RIDER: { text: "Rider cancelled", color: littleRed },
    CANCEL_BY_DRIVER: { text: "Driver cancelled", color: littleRed },
    CANCEL_BY_ADMIN: { text: "Admin cancelled", color: littleRed },
    REJECT: { text: "Reject", color: littleRed },
    REQUEST: { text: "Requested", color: littleBlue },
    ACCEPT: { text: "Accepted", color: littleBlue },
    START_PICKUP: { text: "Start Pickup", color: littleGreen },
    END_PICKUP: { text: "End Pickup", color: littleGreen },
    START_TRIP: { text: "Started", color: littleGreen },
    STOP_PASS: { text: "Passed", color: littleGreen },
    END_TRIP: { text: "Ended", color: littleRed },
    INVOICE: { text: "Invoice", color: littleYellow },
    RATING: { text: "Rating", color: littleYellow },
  };
  return (
    <React.Fragment>
      {(isEditRouteBookingResponse || isCancelBookingResponse) && (
        <Snackbar
          open={true}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={() =>
            isEditRouteBookingResponse
              ? setIsEditRouteBookingResponse(false)
              : setIsCancelBookingResponse(false)
          }
        >
          <Alert
            onClose={() =>
              isEditRouteBookingResponse
                ? setIsEditRouteBookingResponse(false)
                : setIsCancelBookingResponse(false)
            }
            severity={
              isEditRouteBookingResponse
                ? isEditRouteBookingResponse.status
                : isCancelBookingResponse.status
            }
            sx={{ width: "100%", backgroundColor: "rgba(42, 149, 69, 255)" }}
          >
            {isEditRouteBookingResponse?.status
              ? isEditRouteBookingResponse.message
              : isCancelBookingResponse.message}
          </Alert>
        </Snackbar>
      )}
      {isLoading && (
        <Backdrop
          sx={{
            color: "rgba(34, 137, 203, 255)",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog
        open={isEditIconClicked}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please select a driver that you want to add for booking
          </DialogContentText>
          <Autocomplete
            id="tags-standard"
            options={driversList}
            getOptionLabel={(driver) =>
              driver?.driverName + " (" + driver.driverCarModel + ")"
            }
            onChange={(e, newValue) =>
              (selectedDriverEmailId = newValue.driverEmailId)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Driver Name"
                placeholder="Search Driver"
              />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button label="Cancel" size="small" onClick={() => setIsEditIconClicked(false)} />
          <Button
            label="Save Changes"
            size="small"
            onClick={() => {
              changedDateTime = "";
              setIsEditIconClicked(false);
              setIsEditRouteBookingClicked(true);
            }}
            autoFocus
          />
        </DialogActions>
      </Dialog>
      <Dialog open={isTimeEdited}>
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to change the timing?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            size="small"
            onClick={() => {
              setIsTimeEdited(false);
            }}
          />
          <Button
            label="Yes"
            size="small"
            onClick={() => {
              setIsTimeEdited(false);
              setIsEditRouteBookingClicked(true);
            }}
          />
        </DialogActions>
      </Dialog>
      <Dialog open={isCancelBookingDialogOpen}>
        <DialogTitle>Alert</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to cancel the bookings for the selected dates?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            label="Cancel"
            size="small"
            onClick={() => {
              setIsCancelBookingDialogOpen(false);
            }}
          />
          <Button
            label="Yes"
            size="small"
            onClick={() => {
              setIsConfirmCancelBookingClicked(true);
              setIsCancelBookingDialogOpen(false);
            }}
          />
        </DialogActions>
      </Dialog>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
        <Paper
          sx={{
            width: "100%",
            mb: 2,
            borderRadius: "10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            border: "none",
            borderBottom: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              px: 2,
              pt: 1,
              pb: 1,
              borderRadius: "10px",
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 1, md: 0 },
            }}
          >
            <Box component="h2" sx={{ m: 0, display: "flex", alignItems: "center" }}>
              <PortalTitle fallback="Trips" />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "12px",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
              }}
            >
              <EnhancedTableToolbar
                setIsExportButtonClicked={setIsExportButtonClicked}
                setIsAddKmButtonClicked={setIsAddKmButtonClicked}
                setIsRefereshData={setIsRefereshData}
                setStartDateValue={setStartDateValue}
                setEndDateValue={setEndDateValue}
                startDateValue={startDateValue}
                endDateValue={endDateValue}
                setIsEditIconClicked={setIsEditIconClicked}
                selected={selected}
                setIsFilterIconClicked={setIsFilterIconClicked}
                setIsAddDriverClicked={setIsAddDriverClicked}
                setIsCancelBookingDialogOpen={setIsCancelBookingDialogOpen}
                selectedCorporateDetails={selectedCorporateDetails}
                tripsData={tripsData}
                setTripsData={setTripsData}
                filteredData={filteredData}
                setFilteredData={setFilteredData}
                setSelectedCorporateDetails={setSelectedCorporateDetails}
                dataLoading={dataLoading}
              />
            </Box>
          </Box>

            <TableContainer
            component={Paper}
            sx={{
              borderRadius: "10px",
              boxShadow: "none",
              border: "none",
              borderBottom: "none",
              "& .MuiPaper-root": {
                border: "none",
                borderBottom: "none",
              },
            }}
          >
            <Table
              sx={{
                minWidth: 750,
                fontFamily: "Montserrat",
              }}
              aria-labelledby="tableTitle"
              size="medium"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={filteredData?.length}
                selectedCorporateDetails={selectedCorporateDetails}
                roleId={roleId}
              />
              {dataLoading ? (
                <TableBody>
                  <TableRow padding="none">
                    <TableCell colSpan={9} align="center" padding="none">
                      <CircularProgress size="2rem" />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody>
                  <>
                    {visibleRows?.map((row, index) => {
                      const isItemSelected = isSelected(row?.DriverTripID);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      const tripStatus = row?.TripStatus;
                      const statusInfo = statusMapping[tripStatus] || {
                        text: tripStatus,
                        color: "gray",
                      };

                      const driverDetails = row?.DriverDetails
                        ? JSON.parse(row.DriverDetails)
                        : null;
                      const vehicleDetails = row?.VehicleDetails
                        ? JSON.parse(row.VehicleDetails)
                        : null;
                      const corporateDetails = row?.CorporateDetails
                        ? JSON.parse(row.CorporateDetails)
                        : null;
                      const riderDetails = row?.RiderDetails
                        ? JSON.parse(row.RiderDetails)
                        : null;

                      return (
                        <React.Fragment>
                          <TableRow
                            hover
                            // role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={index}
                            selected={isItemSelected}
                            sx={{ cursor: "pointer" }}
                            onClick={() => {
                              if (!dateTimeChangeFlag)
                                setExpandedPanel(
                                  expandedPanel === row?.DriverTripID
                                    ? ""
                                    : row?.DriverTripID
                                );
                            }}
                          >
                            <TableCell padding="none">
                              <div style={{ paddingLeft: "10px" }}>
                                {expandedPanel === row?.DriverTripID ? (
                                  <ExpandLessIcon />
                                ) : (
                                  <ExpandMoreIcon />
                                )}
                              </div>
                            </TableCell>
            <TableCell
              className="tableCellStyle"
              id={labelId}
              scope="row"
              padding="none"
              align="left"
              sx={{
                minWidth: "140px",
                width: "140px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Tooltip
                  title={
                    copiedItemId === row?.DriverTripID
                      ? "Copied!"
                      : "Copy Trip ID"
                  }
                  arrow
                >
                  <IconButton
                    size="small"
                    onClick={(event) =>
                      handleCopyClick(event, row?.DriverTripID)
                    }
                    sx={{ 
                      padding: "2px",
                      "& .MuiSvgIcon-root": {
                        fontSize: "0.875rem",
                        color: "#9e9e9e",
                      },
                      "&:hover .MuiSvgIcon-root": {
                        color: "#757575",
                      },
                    }}
                  >
                    <FileCopyIcon />
                  </IconButton>
                </Tooltip>
                <span>{row?.DriverTripID.substring(0, 8) + "..."}</span>
              </Box>
            </TableCell>
                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {/* <p>{row?.DriverName}</p> */}
                              <p>{driverDetails?.DriverName}</p>
                              {row.shiftRegNumber ? (
                                <p style={{ fontSize: "75%", color: "gray" }}>
                                  {row?.vehicleModel}, {row.shiftRegNumber}
                                </p>
                              ) : (
                                <p style={{ fontSize: "75%", color: "gray" }}>
                                  {vehicleDetails?.model},{" "}
                                  {vehicleDetails?.regNumber}
                                </p>
                              )}

                              {/* <p style={{ fontSize: "75%", color: "gray" }}>
                                {vehicleDetails?.model},{" "}
                                {vehicleDetails?.regNumber}
                              </p> */}
                            </TableCell>
                            {localStorage.getItem("roleId") == "1" && (
                              <TableCell
                                align="center"
                                padding="none"
                                className="tableCellStyle"
                              >
                                <p>
                                  {corporateDetails?.name
                                    ? corporateDetails?.name
                                    : "-"}
                                </p>
                              </TableCell>
                            )}

                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {row?.TripType}
                            </TableCell>

                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {row?.riderNames === ""
                                ? getRiderInfo(row.RiderDetails)
                                : row?.riderNames}
                            </TableCell>

                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {FormatDateTime(row?.ActualPickupDateTime) ?? "-"}
                            </TableCell>
                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {row.ActualDropDateTime !== null
                                ? FormatDateTime(row?.ActualDropDateTime)
                                : "-"}
                            </TableCell>

                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {row?.ActualTripTime
                                ? `${Math.floor(
                                    parseFloat(row.ActualTripTime)
                                  )} min`
                                : "-"}
                            </TableCell>
                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              {TripDistanceRoundOff(
                                Math.ceil(
                                  row?.ActualPickupDistance +
                                    row?.ActualTripDistance
                                )
                              )}{" "}
                              km
                            </TableCell>
                            <TableCell
                              align="center"
                              padding="none"
                              className="tableCellStyle"
                            >
                              <div
                                style={{
                                  color: statusInfo.color,
                                  border: `1px solid ${statusInfo.color}`,
                                  borderRadius: "10px",
                                  padding: "2px 5px",
                                  fontWeight: "500",
                                  fontSize: "10px",
                                  textAlign: "center",
                                  textTransform: "capitalize",
                                  width: "auto",
                                  margin: "auto 8px",
                                }}
                              >
                                {statusInfo.text}
                              </div>
                            </TableCell>
                          </TableRow>
                          {expandedPanel === row?.DriverTripID && (
                            <TableRow>
                              <TableCell
                                colSpan={11}
                                align="center"
                                sx={{ backgroundColor: "#f8fcfd" }}
                              >
                                <RidersData
                                  journeyId={row?.DriverTripID}
                                  tripType={row?.TripType}
                                />
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </>
                  {!visibleRows && (
                    <TableRow>
                      <TableCell
                        sx={{ fontFamily: "Montserrat" }}
                        colSpan={9}
                        align="center"
                      >
                        No Data Available
                      </TableCell>
                    </TableRow>
                  )}
                  {emptyRows > 0 && (
                    <TableRow
                      style={{
                        height: 53 * emptyRows,
                      }}
                    >
                      <TableCell colSpan={7} />
                    </TableRow>
                  )}
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Box
            sx={{
              position: "sticky",
              bottom: 0,
              background: "white",
              zIndex: 1,
              border: "none !important",
              borderTop: "none !important",
              borderBottom: "none !important",
              "&::before": {
                display: "none",
              },
              "&::after": {
                display: "none",
              },
            }}
          >
            <Box
              display="flex"
              sx={{
                paddingRight: "16px",
                marginTop: "8px",
                alignContent: "center",
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                border: "none !important",
                borderTop: "none !important",
                borderBottom: "none !important",
                "&::before": {
                  display: "none",
                },
                "&::after": {
                  display: "none",
                },
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  margin: "initial",
                  marginLeft: "2%",
                }}
              >
                <strong style={{ fontSize: "0.875rem", color: "green" }}>
                  Started:{" "}
                </strong>
                <span style={{ fontSize: "0.8rem" }}>{startedTripCount}</span>{" "}
                <strong style={{ fontSize: "0.875rem" }}>| </strong>
                <strong style={{ fontSize: "0.8rem", color: "red" }}>
                  Ended:{" "}
                </strong>
                <span style={{ fontSize: "0.8rem" }}>{endedTripCount}</span>
                <strong style={{ fontSize: "0.875rem" }}> | Distance:</strong>
                <span style={{ fontSize: "0.8rem" }}>
                  {" "}
                  {totalDistance && totalDistance} Km
                </span>
              </Typography>

              <CommonTablePagination
                page={page}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                setPage={setPage}
                filteredData={filteredData}
                styling={{
                  display: "flex",
                  justifyContent: "flex-end",
                  border: "none",
                  borderTop: "none",
                  borderBottom: "none",
                  "& .MuiTablePagination-root": {
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "&::before": {
                      display: "none",
                    },
                    "&::after": {
                      display: "none",
                    },
                  },
                  "& .MuiTablePagination-toolbar": {
                    border: "none",
                    borderTop: "none",
                    borderBottom: "none",
                    "&::before": {
                      display: "none",
                    },
                    "&::after": {
                      display: "none",
                    },
                  },
                  "& .MuiTablePagination-spacer": {
                    border: "none",
                  },
                }}
              />
            </Box>
          </Box>
        </Paper>
      </Box>
      <Backdrop
        sx={{ color: "rgba(34, 137, 203, 255)", zIndex: "10" }}
        open={isExportButtonClicked}
      ></Backdrop>
      {isExportButtonClicked && (
        <Modal
          setIsExportButtonClicked={setIsExportButtonClicked}
          type="trips"
        />
      )}

      {/* This is for Add new Km */}
      <Backdrop
        sx={{ color: "rgba(34, 137, 203, 255)", zIndex: "10" }}
        open={isAddKmButtonClicked}
      ></Backdrop>
      {isAddKmButtonClicked && (
        <ExtraKm
          setIsAddKmButtonClicked={setIsAddKmButtonClicked}
          setIsRefereshData={setIsRefereshData}
          type="trips"
        />
      )}
    </React.Fragment>
  );
}
